import styled from 'styled-components';

const VideoHolder = styled.div`
	position: relative;
	background-color: white;
	border: 1px solid #d2d9df;

	&.wide {
		grid-column: 1 / 4 !important;
	}

	a {
		cursor: pointer;
		text-decoration: none;
	}

	.video-thumb-header {
		background-color: black;
	}

	.video-thumb {
		display: block;
		width: 100%;
		object-fit: contain;
		margin: 0 auto;
	}

	.live-info {
		position: absolute;
		background: rgba(1, 0, 5, 0.71);
		color: white; 
		padding: 10px;
		top: 0px;
		border-bottom-right-radius: 8px;
	}

	.video-info {
		background-color: white;
		padding: 0px 0px 25px 25px;

		&__details-cont {
			padding-right: 25px;
		}

		&__btns-cont {
			width: 100%;
			padding-top: 10px;
			@media only screen
			and (max-device-width: 768px)
			and (orientation: portrait) {
				max-width: 100%;
			}
			&.centered {
				max-width: 450px;
				margin: 0 auto;
				margin-bottom: 20px;
			}

			button {
				font-family: "Open Sans", sans-serif;
				background-color: #fdfdfc;
				padding: 5px 10px 5px 10px;
				color: #726b55;
				border: 1px solid #d1cdc1;
				font-size: 14px;
				font-weight: 400;
				border-radius: 4px;
				margin-left: 5px;
				cursor: pointer;

				@media only screen 
				and (min-device-width: 768px) 
				and (max-device-width: 1024px) 
				and (orientation: landscape) 
				and (-webkit-min-device-pixel-ratio: 1) {
					font-size: 12px;
				}

				&:hover {
					color: white;
					background-color: #a69e87;
					svg {
						color: white;
					}
				}
				&:first-of-type {
					margin-left: 0;
				}
				&:last-of-type {
					float: right;
					border: none;
					background-color: #726b55;
					color: #fdfdfc;
					border-radius: 0;
					border-bottom-left-radius: 8px;
					top: -20px;
					margin-top: -10px;
					font-weight: 700;
					text-transform: uppercase;
					padding: 10px 0px 10px 10px;
					font-size: 14px;

					@media only screen 
					and (min-device-width: 768px) 
					and (max-device-width: 1024px) 
					and (orientation: landscape) 
					and (-webkit-min-device-pixel-ratio: 1) {
						font-size: 11px;
					}

					@media only screen and (max-width: 920px) {
						display:none;
					}

					svg {
						color: #fdfdfc;
						font-size: 10px;
						margin-left: 10px;
					}
					&:hover {
						color: #fdfdfc;
						background-color: #a69e87;
					}
				}

				svg {
					color: #726b55;
					font-size: 8px;
					margin-right: 10px;
					margin-bottom: 1px;
				}

			}

		}
		&__details-cont {
			.title {
				display: table;
				color: #726b55;
				font-weight: 400;
				font-size: 26px;
				font-size: 1.6rem;
				&:hover {
					color: #5f7586;
				}
				&.in-video-page {
					cursor: default;
					&:hover {
						color: #7a7652;
					}
				}
				&.in-landing-page {
					text-align: left;
					cursor: default;
				}
			}
			.category {
				display:table;
				color: #5f7586;
				font-weight: 900;
				font-size: 1rem;
				text-transform: uppercase;
				padding: 15px 0px 0px 0px;
				cursor: pointer;
				&.hide {
					display: none;
				}
			}
			.description {
				color: #383838;
				font-weight: 500;
				font-size: 17px;
				@media only screen and (max-width: 548px) {
					margin-right: 20px;
				}
				
				&__container-relative {
					position: relative;
				}
				&__ellipsis {
					color: #7a7652;
					text-shadow: none;
					cursor: pointer;
					margin-left: 5px;
					&:hover {
						color: #606060;
					}
				}
			}
			.description-landing {
				color: #383838;
				font-weight: 500;
				font-size: 17px;
				text-align: left;
				@media only screen and (max-width: 548px) {
					margin-right: 20px;
				}
			}
		}
	}

	.article-tag-container {
		margin: 0 0 0 0;
		hr {
			margin-top: 1rem;
			margin-bottom: 1rem;
			border: 0;
			border-top: 1px solid rgba(0, 0, 0, 0.1);
		}
		a {
			display: inline-block;
			.article-tag {
				font-family: "Open Sans", sans-serif;
				font-weight: 600;
				font-size: 14px;
				margin: 0px 10px 15px 0px;
				color: #383838;
				.tag-icon {
					height: 20px;
					width: 20px;
					filter: invert(.7) sepia(.5) brightness(95%);
					margin: 0 5px -3px 0;
					transform: rotate(270deg);
				}
			}
		}
	}
`;

export default VideoHolder;